import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";

import { SharePopup } from "@/components/index";
import { useSubscriptionsContext } from "@/contexts/subscriptions";
import { ShareIcon } from "../../../assets/CommonIcons";
import { removeTags } from "@/shared/utils/content/content";

import styles from "./subscriptions.module.scss";
import IconView from "@/shared/components/IconView/IconView";

const Thoughts = () => {
  const { t } = useTranslation();
  const { fetchThoughts, date, thoughts } = useSubscriptionsContext();

  useEffect(() => {
    fetchThoughts();
  }, [fetchThoughts]);

  const dateThoughts = thoughts[date] || [];

  if (!dateThoughts.length) {
    return <div className={styles["subs-default-text"]}>{t("noThoughts")}</div>;
  }

  return dateThoughts.map((item, index) => {
    return (
      <div key={index} className={styles["subs-thought-item"]}>
        <div
          className={styles["subs-thought-item-content"]}
          dangerouslySetInnerHTML={{ __html: item.content }}
        />
        <div className={styles["subs-thought-item-title"]}>
          <div className={styles["subs-thought-item-title-text"]}>{item.title}</div>
          <SharePopup
            url=""
            title={item.title}
            text={removeTags(item.content)}
            renderButton={({ show, onClick }) => {
              return (
                <IconView
                  icon={ShareIcon}
                  className={styles["subs-share-icon"] + (show ? " active" : "")}
                  onClick={onClick}
                />
              );
            }}
          />
        </div>
      </div>
    );
  });
};

Thoughts.propTypes = {
  thoughts: PropTypes.object,
  setThoughts: PropTypes.func,
};

export default Thoughts;
